import { render, staticRenderFns } from "./AdminOrgGao.vue?vue&type=template&id=024d1882&scoped=true&"
import script from "./AdminOrgGao.vue?vue&type=script&lang=js&"
export * from "./AdminOrgGao.vue?vue&type=script&lang=js&"
import style0 from "./AdminOrgGao.vue?vue&type=style&index=0&id=024d1882&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024d1882",
  null
  
)

export default component.exports